import React from 'react';
import pt from 'prop-types';
import { Stack } from '@metarouter-private/mr-mui';

import CurrentOrgBanner from './CurrentOrgBanner';
import OrgSearch from './OrgSearch';
import OrgList from './OrgList';

export default function OrgSwitcherContent({
  onSelectCurrent,
  currentOrgName,
  orgs,
  loading,
  search,
  setSearch,
  switchTo,
  switching,
}) {
  return (
    <Stack spacing={2}>
      <Stack spacing={1}>
        <CurrentOrgBanner name={currentOrgName} switching={switching} onSelect={onSelectCurrent} />
        <OrgSearch search={search} setSearch={setSearch} />
      </Stack>
      <OrgList orgs={orgs} search={search} loading={loading} switching={switching} switchTo={switchTo} />
    </Stack>
  );
}

OrgSwitcherContent.propTypes = {
  onSelectCurrent: pt.func.isRequired,
  currentOrgName: pt.string.isRequired,
  orgs: pt.array.isRequired,
  loading: pt.bool.isRequired,
  search: pt.string.isRequired,
  setSearch: pt.func.isRequired,
  switchTo: pt.func.isRequired,
  switching: pt.bool.isRequired,
};
